import { IS_LOCAL } from '../../../../constants'
import { ApiService } from 'shared/http/v2/http.mixin'
import { ListProducts, ListSuggests } from './type'
import { fakeProducts, fakeSuggests } from './fake'

export class FilterAPI extends ApiService({ basePath: '/filters', apiVersion: 'v2' }) {
  public static async listProducts(): Promise<ListProducts> {
    if (IS_LOCAL) {
      return fakeProducts()
    }

    const resp = await this.http.get<ListProducts>('/products')

    if (resp.status !== 200) {
      throw new Error(resp.error)
    }

    return resp.data
  }

  public static async listSuggests(): Promise<ListSuggests> {
    if (IS_LOCAL) {
      return fakeSuggests()
    }

    const resp = await this.http.get<ListSuggests>('/suggests')

    if (resp.status !== 200) {
      throw new Error(resp.error)
    }

    return resp.data
  }
}
